import React from 'react'
import { Image, LayoutBand, Paragraph, Row, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import searchRecordImg from '../../images/search-record.png'

const SelectImagePrompt = () => {
  const [t] = useTranslation()

  return (
    <LayoutBand>
      <Separator />
      <Row alignX="center">
        <Image src={searchRecordImg} alt="" maxWidth={250} />
      </Row>
      <Paragraph size="sm" centered>
        {t('sideSheet.selectImagePrompt', 'Select an image to view indexed names')}
      </Paragraph>
    </LayoutBand>
  )
}

export default SelectImagePrompt
